<form [formGroup]="formName">
    @if(!field.multi) {
    @if (field.attributeCode === 'gender') {
    <p-dropdown
        #miSelect
        [options]="field.presetValues"
        [placeholder]="placeholder"
        optionValue="labelValue"
        optionLabel="labelValue"
        (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode">
        <ng-template let-value pTemplate="item">
            <div class="flex align-items-center gap-2">
                <i class="mi-lg wh-15" [class]="value.labelValue.toLowerCase() + '_gender'"></i>
                <div>{{ value.labelValue }}</div>
            </div>
        </ng-template>
    </p-dropdown>

    } @else if (field.attributeCode === 'group_color') {
    <p-dropdown #miSelect [options]="field.presetValues" [placeholder]="placeholder" optionValue="labelValue"
        optionLabel="labelValue" (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode">
        <ng-template let-value pTemplate="item">
            <div class="flex align-items-center gap-2">
                <i class="mi-lg" [class]="value.labelValue.toLowerCase()"></i>
                <span class="item-content">
                    <app-group-color [colorCode]="value.color" [moduleName]="'driver_group'"></app-group-color>
                    {{value.labelValue}}
                </span>
            </div>
        </ng-template>
    </p-dropdown>
    } @else if (field.attributeCode === 'color') {
    <p-dropdown #miSelect [options]="field.presetValues" [placeholder]="placeholder" optionValue="labelValue"
        optionLabel="labelValue" (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode">
        <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
                <app-group-color [colorCode]="item.labelValue"></app-group-color>
            </div>
        </ng-template>
    </p-dropdown>
    } @else if (field.attributeCode === 'vehicle_body_type_preference') {
    <p-dropdown #miSelect [options]="field.presetValues" [placeholder]="placeholder" optionValue="labelValue"
        optionLabel="labelValue" (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"></p-dropdown>
    } @else if (field.attributeCode === 'reporter_type') {
    <p-dropdown #miSelect [options]="field.presetValues" [placeholder]="placeholder" optionValue="labelValue"
        optionLabel="labelValue" (onChange)="changedSelectedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"></p-dropdown>
    }
    @else if (field.attributeCode === 'dispatch_zone' || field.attributeCode === 'region_geofence'){
    <p-dropdown #dropdown [options]="field.presetValues" [placeholder]="placeholder" optionValue="labelKey"
        optionLabel="labelValue" (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode">
        <ng-template let-value pTemplate="selectedItem">
            <div class="flex align-items-center justify-content-between w-full">
                <span>{{ value ? value.labelValue : placeholder }}</span>
                @if (value) {
                <i class="pi pi-times cursor-pointer clear-dispatch-zone" (click)="clearSelectedDispatchZone()"></i>
                }
            </div>
        </ng-template>
    </p-dropdown>
    } @else if(field.attributeCode === 'userType'){
    <p-dropdown class="quick-filter-dw" #miSelect [options]="field.presetValues" [placeholder]="placeholder"
        optionValue="labelValue" optionLabel="labelKey" (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [showClear]="miSelect.value ? true : false"></p-dropdown>
    } @else if(field.attributeCode === 'time_zone'){
    <p-dropdown #miSelect [options]="field.presetValues" [placeholder]="placeholder" optionValue="value"
        optionLabel="labelValue" (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [filter]="true" [disabled]="field.disabled"
        [style]="field.disabled ? {'opacity': '0.5', 'pointer-events': 'none'} : {}"></p-dropdown>
    } @else if(field.attributeCode === 'rejection_reason_type'){
    <p-dropdown #miSelect [options]="field.presetValues" [placeholder]="placeholder" optionValue="labelKey"
        optionLabel="labelValue" (onChange)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"></p-dropdown>
    } @else {
    <p-dropdown #miSelect [options]="field.presetValues" [placeholder]="placeholder" optionValue="labelKey"
        optionLabel="labelValue" (change)="changedValue(miSelect.value)"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"></p-dropdown>
    }
    }
    @if(field.multi) {
    @if (moduleName === 't_conf_sett') {
    <p-multiSelect #miSelect
        [options]="field.presetValues"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [placeholder]="placeholder"
        optionValue="labelValue"
        optionLabel="labelKey"
        [display]="multiSelectDisplay"
        appendTo="body"
        (onFilter)="onFilter($event)">

        <ng-template pTemplate="filtericon">
            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
        </ng-template>
    </p-multiSelect>
    } @else if (moduleName === 'pass_privilege_conf') {
    @if(field.attributeCode === 'vehicle_type') {
    <p-multiSelect #miSelect
        [options]="field.presetValues"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [placeholder]="placeholder"
        optionValue="labelValue"
        optionLabel="labelValue"
        (onChange)="changedMultiValue(miSelect.value)"
        [display]="multiSelectDisplay"
        (onFilter)="onFilter($event)">

        <ng-template pTemplate="filtericon">
            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
        </ng-template>
    </p-multiSelect>
    }
    @else if(field.attributeCode === 'vehicle_body_type') {
    <p-multiSelect #miSelect
        [options]="getVehicleBodyTypeList()"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [placeholder]="placeholder"
        optionValue="labelValue"
        optionLabel="labelValue"
        [display]="multiSelectDisplay"
        (onFilter)="onFilter($event)">

        <ng-template pTemplate="filtericon">
            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
        </ng-template>
    </p-multiSelect>
    } @else {
    <p-multiSelect #miSelect
        [options]="field.presetValues"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [placeholder]="placeholder"
        optionValue="labelValue"
        optionLabel="labelValue"
        [display]="multiSelectDisplay"
        (onFilter)="onFilter($event)">

        <ng-template pTemplate="filtericon">
            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
        </ng-template>
    </p-multiSelect>
    }
    } @else if (field.attributeCode === 'user_parent') {
    <p-multiSelect #miSelect
        [options]="field.presetValues"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [placeholder]="placeholder"
        optionValue="labelKey"
        optionLabel="labelValue"
        [display]="multiSelectDisplay"
        (onFilter)="onFilter($event)">

        <ng-template pTemplate="filtericon">
            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
        </ng-template>
    </p-multiSelect>
    } @else {
    <p-multiSelect #miSelect
        [options]="field.presetValues"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [placeholder]="placeholder"
        optionValue="labelValue"
        optionLabel="labelValue"
        [display]="multiSelectDisplay"
        (onFilter)="onFilter($event)">

        <ng-template pTemplate="filtericon">
            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
        </ng-template>
    </p-multiSelect>
    }
    }
</form>